import React from 'react'
import PropTypes from 'prop-types'
import Auth from '../auth/Auth'
import '../css/styles.css'
import { Grid, Row, Col } from 'react-flexbox-grid'

import Paper from '@material-ui/core/Paper'
import { injectIntl, intlShape } from 'react-intl'
import {
  localize
} from '../util/Localizer'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { BenefitCard } from '../assets/images'
import Config from '../Config'
import { resetMessage, logout } from '../redux/actions/logoutActions'
import { login, validateSession, loginWithPolicy, saveUserData } from '../redux/actions/loginActions'

import { toggleLanguage } from '../redux/actions/languageActions'
import { fetchAppContent } from '../redux/actions/appContentActions'
import Loading from '../widgets/Loading'
import { Redirect } from 'react-router-dom'

// Our Components
import TopNav from '../widgets/common/TopNav'
import ErrorMessage from '../widgets/common/ErrorMessage'
import RBButton from '../controls/RBButton'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { withStyles } from '@material-ui/core/styles'
import { Dimensions } from '../theme'

class MultiPolicyPage extends React.Component {
  constructor () {
    super()
    this.logout = this.logout.bind(this)
    this.loginWithPolicy = this.loginWithPolicy.bind(this)
    this.renderForm = this.renderForm.bind(this)
    this.renderLoading = this.renderLoading.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.state = {
      policyArray: [],
      selectedPolicy: '',
      userName: '',
      password: '',
      error: '',
      redirect: '',
      isSessionValidation: false
    }
  }

  componentWillMount () {
    const { ngrxMultiPolicies, policyNumber } = Auth
    if (policyNumber) {
      this.setState({ redirect: Config.landingPage })
    } else {
      this.setState({ policyArray: ngrxMultiPolicies })
    }
  }

  logout (e) {
    e.preventDefault()
    this.props.saveUserData('', '', false)
    this.props.logout()
  }

  loginWithPolicy (event) {
    event.preventDefault()
    const { selectedPolicy, policyArray } = this.state
    const { userEmail, userPassword, isSessionValidation } = this.props

    if (!isSessionValidation && (!selectedPolicy || !userEmail || !userPassword)) {
      const error = { message: localize('pages.login.multiPolicy.error') }
      this.setState({ error })
    } else {
      const policy = policyArray.find(pol => pol.policyNumber === selectedPolicy)
      var submitObject = {
        loginDetails: {
          email: userEmail,
          password: userPassword
        },
        policySelectionDetails: {
          policyNumber: policy.policyNumber,
          certificateNumber: policy.certificateNumber
        },
        isSessionValidation: isSessionValidation
      }
      this.props.loginWithPolicy(submitObject)
    }
  }

  handleInputChange (event) {
    const { name, value } = event.target
    this.setState({ [name]: value })
  }

  renderLoading () {
    return (<div>
      <Loading message={localize('common.loadingContent')} />
    </div>)
  }

  renderForm () {
    const { policyArray, selectedPolicy = {} } = this.state
    return (
      <form action='/' id='policy-form' className='clearfix' style={{ marginTop: 50 }} autoComplete='off' onSubmit={this.loginWithPolicy}>
        <ErrorMessage error={this.props.error || this.state.error} />
        <h3>{localize('pages.login.multiPolicy.title')}</h3>
        <p>{localize('pages.login.multiPolicy.text')}</p>
        <RadioGroup
          aria-label={localize('pages.login.multiPolicy.policy')}
          value={selectedPolicy}
          onChange={(e, v) => this.setState({ cob: v }, this.updateNext)}
          className='radio-group'
          name='selectedPolicy'
        >
          {policyArray.map((policy, key) => {
            return (
              <FormControlLabel
                value={policy.policyNumber}
                control={<Radio color={'primary'} />}
                label={policy.policyNumber}
                key={key}
                onChange={this.handleInputChange}
              />
            )
          })}
        </RadioGroup>
        <br />
        <div className='button-container' >
          <RBButton
            label={localize('pages.login.multiPolicy.cancel')}
            variant='outlined'
            styles={{ width: '100%', height: 42 }}
            onClick={this.logout}
          />
          <RBButton
            type='submit'
            id='btnLogin'
            label={localize('pages.login.multiPolicy.continue')}
            variant='contained'
            styles={{ width: '100%', height: 42 }}
            disabled={!selectedPolicy}
            primary
            loading={this.props.pageLoading}
          />
        </div>
      </form>
    )
  }

  render () {
    const { classes = {} } = this.props
    const { redirect } = this.state
    return (
      <div className={classes.loginPage}>
        {redirect && <Redirect to={redirect} /> }
        <Grid fluid>
          <Row end='xs'>
            <Col>
              <TopNav primary />
            </Col>
          </Row>
          <Row center='lg' className={classes.screenHeight}>
            <Col xs={12} md={3} lg={3} />
            <Col xs={12} md={6} lg={6} id='login'>
              <Paper elevation={2} className={classes.loginCard}>
                <img src={BenefitCard} alt={localize('pages.login.multiPolicy.benefitcard')} />
                {this.renderForm()}
              </Paper>
            </Col>
            <Col xs={12} md={3} lg={3} />
          </Row>
        </Grid>
      </div>

    )
  }
}

MultiPolicyPage.contextTypes = {
  intl: intlShape.isRequired,
  router: PropTypes.object
}

function mapStateToProps (state) {
  return {
    user: state.user,
    pageLoading: state.LoginReducers.pageLoading,
    error: state.LoginReducers.error,
    msg: state.LogoutReducers.msg,
    appContent: state.AppContentReducer.appContent || {},
    valLoading: state.LoginReducers.valLoading,
    valerror: state.LoginReducers.valerror,
    userEmail: state.LoginReducers.userEmail,
    userPassword: state.LoginReducers.userPassword,
    isSessionValidation: state.LoginReducers.isSessionValidation
  }
}

const ConnectedMultiPolicyPage = connect(mapStateToProps, {
  login,
  logout,
  saveUserData,
  loginWithPolicy,
  toggleLanguage,
  resetMessage,
  push,
  validateSession,
  fetchAppContent
})(injectIntl(MultiPolicyPage))

const styles = {
  loginPage: {
    overflowY: 'scroll',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  loginCard: {
    width: '100%',
    maxWidth: '850px',
    padding: '45px 100px',
    textAlign: 'center',
    display: 'inline-block',
    '& img': {
      maxWidth: Dimensions.loginLogoMaxWidth
    },
    ['@media all and (max-width:525px)']: { // eslint-disable-line no-useless-computed-key
      padding: '45px 60px'
    },
    ['@media all and (max-width:375px)']: { // eslint-disable-line no-useless-computed-key
      padding: '45px 30px'
    }
  },
  screenHeight: {
    minHeight: 'calc(100vh)'
  }
}

export default withStyles(styles)(ConnectedMultiPolicyPage)



// WEBPACK FOOTER //
// ./src/components/MultiPolicyPage.js